module.exports = __webpack_public_path__ + "img/image-full-width.24cf0bbe.png";